'use es6';

import { createSelector } from 'reselect';
import { getIndexedAsyncInlineImageStatusData } from './getIndexedAsyncInlineImageStatusData';
import { getEntry } from 'conversations-async-data/indexed-async-data/operators/getters';
import { getData } from 'conversations-async-data/async-data/operators/getters';
export const getShouldDisplayImageProcessingBannerById = messageId => createSelector(getIndexedAsyncInlineImageStatusData, indexInlineImages => {
  const entry = getEntry(messageId, indexInlineImages);
  return getData(entry);
});